<template>
  <CForm class="form-consulta">
    <CCard v-show="typeUser != 'Profissional'">
      <CCardBody>
        <CButton style="width: 100px; color: white" block color="primary"
          ><router-link
            class="router-link"
            :to="{ path: '/consultas', query: { type: 'a' } }"
            >Cadastrar</router-link
          ></CButton
        >
        <div></div>
      </CCardBody>
    </CCard>

    <CCard>
      <CAlert color="warning" id="aviso" :show.sync="alertaAviso" closeButton>{{
        mensagem
      }}</CAlert>
      <CModal class="modal-excluir-consulta" :show.sync="showModal">
        <div class="div-body-modal">
          <img src="../../../assets/atencao.jpg" width="120px" height="120px" alt="" />
          <h4>ATENÇÃO</h4>

          <p>{{ msgModal }}</p>

          <button type="button" v-show="btn_excluir_inModal" @click="excluir()">
            EXCLUIR
          </button>
          <button
            type="button"
            v-show="btn_cancelar_inModal"
            class="btn-modal"
            @click="showModal = false"
          >
            CANCELAR
          </button>
          <button type="button" @click="showModal = false" v-show="btn_voltar_inModal">
            VOLTAR
          </button>
        </div>
      </CModal>
      <CModal class="modal-excluir-consulta" :show.sync="modal_cancel_consult">
        <div class="div-body-modal">
          <img src="../../../assets/atencao.jpg" width="120px" height="120px" alt="" />
          <h4>{{ title_modal }}</h4>
          <span class="alert_adiantamento">{{ msgModalAdiantamento }}</span>
          <div v-if="!temAdiantamento">
            <p class="text-modal">{{ text_modal }}</p>
            <div>
              <button type="button" @click="confirmCancel()" v-show="btn_excluir_inModal">
                SIM
              </button>
              <button
                type="button"
                class="btn-modal"
                @click="modal_cancel_consult = false"
                v-show="btn_cancelar_inModal"
              >
                NÃO
              </button>
            </div>
          </div>
          <button
            type="button"
            @click="modal_cancel_consult = false"
            v-show="btn_voltar_inModal"
          >
            VOLTAR
          </button>
        </div>
      </CModal>
      
            <!-- Modal de Opções de Exportação -->
      <CModal class="modal-export-options" :show.sync="showExportModal">
        <div class="export-modal-body">
          <!-- Header do Modal -->
          <div class="export-header">
            <img
              src="../../../assets/vector_certo_cortado.jpg"
              width="70px"
              height="70px"
              alt=""
            />
            <h3 class="export-main-title">Exportar Relatório Excel</h3>
            <p class="export-subtitle">Selecione uma das opções abaixo para gerar seu relatório</p>
          </div>

          <!-- Informações dos Dados -->
          <div class="export-info-section">
            <div class="info-grid">
              <div class="info-card">
                <div class="info-icon">📄</div>
                <div class="info-text">
                  <div class="info-number">{{ consultas.length }}</div>
                  <div class="info-label">Página Atual</div>
                </div>
              </div>
              <div class="info-card">
                <div class="info-icon">📊</div>
                <div class="info-text">
                  <div class="info-number">{{ totalConsultas.toLocaleString('pt-BR') }}</div>
                  <div class="info-label">Total Filtrado</div>
                </div>
              </div>
            </div>
          </div>

          <!-- Opções de Exportação -->
          <div class="export-options-section">
            <div class="options-grid">
              <!-- Opção 1: Página Atual -->
              <button 
                type="button"
                class="export-choice-btn current-choice"
                @click="confirmExport('current')"
                :disabled="consultas.length === 0"
              >
                <div class="choice-icon">📄</div>
                <div class="choice-title">Página Atual</div>
                <div class="choice-count">{{ consultas.length }} registros</div>
                <div class="choice-description">Processamento rápido</div>
              </button>

              <!-- Opção 2: Todos os Resultados -->
              <button 
                type="button"
                class="export-choice-btn all-choice"
                @click="confirmExport('all')"
                :disabled="totalConsultas === 0"
              >
                <div class="choice-icon">📊</div>
                <div class="choice-title">Todos os Resultados</div>
                <div class="choice-count">{{ totalConsultas.toLocaleString('pt-BR') }} registros</div>
                <div class="choice-description">Relatório completo</div>
              </button>
            </div>
          </div>

          <!-- Filtros Ativos (se houver) -->
          <div class="active-filters-section" v-if="hasActiveFilters()">
            <div class="filters-header">
              <span class="filters-icon">🔍</span>
              <span class="filters-title">Filtros Aplicados</span>
            </div>
            <div class="filters-list">
              <!-- 🔍 Novos filtros -->
              <span v-if="filtroId" class="filter-tag">
                <strong>ID:</strong> {{ filtroId }}
              </span>
              <span v-if="filtroProtocolo" class="filter-tag">
                <strong>Protocolo:</strong> {{ filtroProtocolo }}
              </span>
              <span v-if="filtroGuia || guiaSelecionada" class="filter-tag">
                <strong>Guia:</strong> {{ filtroGuia || guiaSelecionada }}
              </span>
              
              <!-- Filtros existentes -->
              <span v-if="itemSelecionadoPaciente" class="filter-tag">
                <strong>Paciente:</strong> {{ itemSelecionadoPaciente }}
              </span>
              <span v-if="dataInicio && dataFim" class="filter-tag">
                <strong>Período:</strong> {{ dataInicio }} até {{ dataFim }}
              </span>
              <span v-if="statusSelecionado" class="filter-tag">
                <strong>Status:</strong> {{ statusSelecionado }}
              </span>
              <span v-if="profissionalSelecionado" class="filter-tag">
                <strong>Profissional:</strong> {{ profissionalSelecionado }}
              </span>
              <span v-if="convenioSelecionada && convenioSelecionada !== 'todos'" class="filter-tag">
                <strong>Convênio:</strong> {{ convenioSelecionada }}
              </span>
            </div>
          </div>

          <!-- Footer com Botões -->
          <div class="export-footer">
            <div class="footer-info">
              <span class="info-icon">💡</span>
              <span class="info-message">O arquivo será baixado automaticamente em seu computador</span>
            </div>
            <div class="footer-actions">
              <button
                type="button"
                class="cancel-btn"
                @click="showExportModal = false"
              >
                Cancelar
              </button>
            </div>
          </div>

          <!-- Loading Overlay -->
          <div v-if="isExporting" class="export-loading-overlay">
            <div class="loading-content">
              <div class="loading-spinner"></div>
              <h4>Gerando Relatório Excel...</h4>
              <p>Por favor, aguarde enquanto preparamos seu arquivo</p>
            </div>
          </div>
        </div>
      </CModal>

      <CCardBody>
        <CRow style="display: flex">
          <div class="servicos-div">
            <CSelect
              prepend="SERVIÇO"
              :options="tipoServiço"
              :value.sync="tipoServicoSelecionado"
              @change="selecionaTipoServico(tipoServicoSelecionado)"
            >
            </CSelect>

            <div class="div__protocol">
              <CButton
                id="btn_protocol"
                v-show="listItemProtocol.length > 0"
                color="primary"
                square
                variant="outline"
                size="sm"
                @click="sendProtocol()"
              >
                Enviar Protocolo
              </CButton>
              <CInput v-show="listItemProtocol.length > 0" v-model="textProdocol">
              </CInput>
            </div>
            <CButton
              class="mt-2"
              variant="outline"
              v-show="listItemProtocol.length > 0"
              color="danger"
              square
              size="sm"
              @click="excluirConsultas()"
            >
              Excluir
            </CButton>
            
            <!-- Botão de Exportação - Apenas para Admins -->
            <CButton
              class="mt-2 ml-2"
              variant="outline"
              color="success"
              square
              size="sm"
              @click="showExportModal = true"
              v-show="consultas.length > 0 && isAdmin"
            >
              📊 Exportar Excel
            </CButton>
          </div>

          <div style="width: 30%; margin-left: 5vw" v-show="escopoProap">
            <CSelect
              :value.sync="tipo_proapSelecionado"
              :options="psiProapOption"
              v-model="tipo_proapSelecionado"
              prepend="PSI/PROAP"
              placeholder=" "
              @change="proapFiltro"
            >
            </CSelect>
          </div>
        </CRow>
      </CCardBody>
      <CCardBody class="table-consulta">
        <h2 v-if="user == 1 && mostrarValor == true">{{ valorConsultas }}</h2>
        <CDataTable
          clickableRows
          class="table-consulta-list"
          v-if="paginaAtual != 0"
          :items="consultasFiltradas"
          :fields="fields"
          :noItemsView="not_found"
          column-filter
          responsive
          :dark="dark"
          :pagination="pagination"
          :activePage="paginaAtual"
          clickableRows
          @row-clicked="perfilConsulta($event)"
          :items-per-page="10"
          sorter
          hover
        >
          <template #patient-filter="{}">
            <CDropdown
              :togglerText="nomePaciente ? nomePaciente : todos"
              color="white"
              class="dropdownBusca"
            >
              <CInput v-model="filtroInputBusca" @input="filtroBuscaPacientes" />
              <CDropdownItem @click="limparFiltro()">Todos</CDropdownItem>
              <CDropdownItem
                @click="selecionaPaciente(item)"
                class="scroll"
                v-for="(item, key) in listaPacientesFiltroSelect"
                :key="key"
                >{{ item }}
              </CDropdownItem>
            </CDropdown>
          </template>

          <template #date_at-filter="{}">
            <VueHotelDatepicker
              v-if="showFilterDate"
              format="YYYY-MM-DD"
              separator=" até "
              confirmText="Confirmar"
              resetText="Limpar"
              minDate="01-01-2023"
              placeholder="Selecione um intervalo"
              :startDate="dataInicio"
              :endDate="dataFim"
              @update="selecionaDataFilter"
              @confirm="selecionaDataFilter"
              @reset="limpar"
            />
          </template>
          <template #idconvenio-filter="{}">
            <CSelect
              :value.sync="convenioSelecionada"
              :options="listaConvenios"
              @change="selecionaConvenio(convenioSelecionada)"
            />
          </template>
          <template #item="{ item }">
            <td>
              <CBadge :color="getBadge(item.statusconsulta)">{{
                item.statusconsulta
              }}</CBadge>
            </td>
          </template>
          <template #item-filter="{}">
            <CSelect
              :value.sync="statusSelecionado"
              :options="listaStatus"
              @change="filtroStatus(statusSelecionado)"
            />
          </template>
          <template #name-filter="{}">
            <CSelect
              :value.sync="profissionalSelecionado"
              :options="listaProfissionais"
              @change="filtroProfissional(profissionalSelecionado)"
              :disabled="isProfessional"
            />
          </template>
          <template #hour_at-filter="{}">
            <CSelect
              type="time"
              :options="listaHorario"
              :value.sync="horaSelecionada"
              @change="filtroHora(horaSelecionada)"
            />
          </template>
          <template #pagamento-filter="{}">
            <CSelect
              :value.sync="pagamentoSelecionado"
              :options="listaFormasPagamento"
              @change="selecionaPagamento(pagamentoSelecionado)"
            ></CSelect>
          </template>
          <template #check="{ item }">
            <CInputCheckbox
              class="check__box"
              :checked="checkedItems[item.id]"
              square
              @click="setProtocol(item)"
              :disabled="typeUser == 'Profissional'"
              >Marcar</CInputCheckbox
            >
          </template>

          <template #acao="{ item, index }">
            <td class="py-4">
              <CButton color="primary" variant="outline" square size="sm"
                ><router-link
                  class="router-link-ver"
                  :to="{
                    path: `consultas`,
                    name: 'Consultas',
                    query: { id: item.id, type: 'b' },
                  }"
                  >VER</router-link
                ></CButton
              >
            </td>
            <td class="py-4">
              <CButton
                color="danger"
                variant="outline"
                square
                size="sm"
                @click="cancelConsult(item, index)"
                >X</CButton
              >
            </td>
            <td class="py-4">
              <CButton
                color="danger"
                variant="outline"
                square
                size="sm"
                @click="deleteConsult(item, index)"
                >EXCLUIR</CButton
              >
            </td>
          </template>
          <template #social_name-filter="{}">
            <CSelect
              :options="listaNomeSocial"
              :value.sync="nomeSocialSelecionado"
              @change="selecionaNomeSocial(nomeSocialSelecionado)"
            >
            </CSelect>
          </template>
          <template #name_service-filter>
            <CSelect
              :options="tipoServiço"
              :value.sync="tipoServicoSelecionado"
              @change="selecionaTipoServico(tipoServicoSelecionado)"
            >
            </CSelect>
          </template>

          <!-- 🔍 Filtro ID -->
          <template #id-filter>
            <CInput 
              v-model="filtroId" 
              @input="onIdFilterChange"
              placeholder="ID..."
              size="sm"
            />
          </template>

          <!-- 🔍 Filtro Protocolo -->
          <template #protocol-filter>
            <CInput 
              v-model="filtroProtocolo" 
              @input="onProtocoloFilterChange"
              placeholder="Protocolo..."
              size="sm"
            />
          </template>
          <template #protocolo2-filter>
  <CInput 
    v-model="filtroProtocolo2" 
    @input="onProtocolo2FilterChange" placeholder="Protocolo 2..."
    size="sm"
  />
</template>
          <template #guia-filter>
            <CInput v-model="guiaSelecionada" @input="onGuiaFilterChange" placeholder="Guia..." size="sm" />
          </template>
          <template #filtroLimpar-filter>
            <CButton color="primary" square size="sm" @click="LimparFiltros">
              Limpar
            </CButton>
          </template>
        </CDataTable>
      </CCardBody>
      
      <!-- Paginação Server-side -->
      <CPagination
        v-show="consultas.length > 0"
        style="padding-left: 2%"
        size="sm"
        :active-page.sync="paginaAtual"
        :pages="pages"
        responsive
        @update:activePage="onPageChange"
      />
      <div class="pagination-extras" v-if="pages > 1">
        <CButton color="info" size="sm" @click="goToToday" class="mr-2">
          Hoje
        </CButton>
        <span class="pagination-info">
          Mostrando {{ consultas.length }} de {{ totalConsultas }} registros (Página {{ paginaAtual }} de {{ pages }})
        </span>
      </div>
    </CCard>
  </CForm>
</template>
<script>
import moment from "moment";
import VueHotelDatepicker from "@northwalker/vue-hotel-datepicker";
import "babel-polyfill";
import * as XLSX from "xlsx";

export default {
  name: "ListarPacientes",
  components: {
    VueHotelDatepicker,
  },
  data() {
    return {
      checkedItems: [],
      textoTootip: "",
      todos: "Todos",
      query: "",
      title_modal: "ATENÇÃO",
      text_modal: "",
      btn_excluir_inModal: true,
      btn_cancelar_inModal: true,
      modal_cancel_consult: false,
      btn_voltar_inModal: false,
      desativado: false,
      not_found: {
        noResults: "Nenhum registro encontrado",
        noItems: "Nenhum registro encontrado",
      },
      idProfissional: "",
      userLogado: true,
      typeUser: "",
      // check box
      psiProap: false,
      checkProap: false,
      escopoProap: false,
      showModal: false,
      // select servicos exibir
      date: new Date(),

      listServicos: [
        { label: "TODOS", value: null },
        { label: "CONSULTAS", value: 1 },
        { label: "AVALIAÇÕES", value: 2 },
        { label: "CURSOS", value: 3 },
        { label: "PALESTRAS", value: 4 },
      ],
      psiProapOption: [
        { label: "TODOS", value: "todos" },
        { label: "PSI", value: "psi" },
        { label: "PROAP", value: "proap" },
      ],
      alertaAviso: false,
      alertaSucesso: false,
      mensagem: "",
      tipo_servicoSelecionado: "",
      tipo_proapSelecionado: "",
      listItemProtocol: [],
              consultas: [],
        totalConsultas: 0,
        paginaAtual: 1,
        limit: 10,
        pages: 1,
        dataConvertida: [],
        date_at: "",
      textProdocol: "",
      fields: [
        { key: "id", label: "Id", _style: "min-width:50px" },
        {
          key: "check",
          label: "",
          sorter: false,
          filter: false,
        },
        { key: "patient", label: "Paciente", _style: "min-width:200px" },
        { key: "social_name", label: "Nome Social", _style: "min-width:100px" },
        { key: "idconvenio", label: "Convênio", _style: "min-width:150px;" },

        { key: "date_at", label: "Data", _style: "max-width:100px;" },
        { key: "hour_at", label: "Hora", _style: "min-width:40px;" },
        {
          key: "name",
          label: "Profissional",
          _style: "min-width:40px;",
        },

        {
          key: "pagamento",
          label: "Pagamento",
          _style: "min-width:40px;",
        },
        {
          key: "valor",
          label: "Valor",
          _style: "min-width:40px;",
        },
        {
          key: "name_service",
          label: "Serviço",
          _style: "min-width:40px;",
        },
        {
          key: "protocol",
          label: "Protocolo",
          _style: "min-width:40px;",
        },
        {
    key: "protocolo2",
    label: "Protocolo 2", // O título que aparecerá no cabeçalho
    _style: "min-width:40px;",
  },
        {
          key: "guia",
          label: "GUIA",
          _style: "min-width:40px;",
        },

        {
          key: "item",
          label: "Status",
          sorter: false,
          filter: false,
          _style: "min-width:40px;",
        },
        {
          key: "acao",
          label: "",
          sorter: false,
          filter: false,
        },
        {
          key: "filtroLimpar",
          label: "",
          sorter: false,
          filter: false,
        },
      ],
      collapseDuration: 0,
      details: [],
      usuario: {
        id: localStorage.id,
        tipo: localStorage.tipo,
      },
      caption: {
        type: String,
        default: "Table",
      },
      hover: true,
      striped: true,
      bordered: false,
      small: true,
      fixed: true,
      dark: false,
      pagination: true,
      id_consult: "",
      status_consult: "",
      cancel_consult: "",
      msgModal: "",
      statusSelecionado: "",
      listaConvenios: [
        {
          label: "Todos",
          value: "todos",
        },
      ],

      convenioSelecionada: "todos",
      consultasFiltradas: [],

      listaStatus: [
        {
          label: "Todos",
          value: "todos",
        },
        {
          label: "Criada",
          value: "Criada",
        },
        {
          label: "Evolucao",
          value: "Evolucao",
        },
        {
          label: "Não Compareceu",
          value: "Não Compareceu",
        },
        {
          label: "Sem Guia",
          value: "Sem Guia",
        },
        {
          label: "Sem Protocolo",
          value: "Sem Protocolo",
        },
        {
          label: "Finalizada",
          value: "Finalizada",
        },
        {
          label: "Cancelada",
          value: "Cancelada",
        },
      ],
      listaPacientesFiltro: [],
      listaPacientesFiltroSelect: [],
      filtroInputBusca: "",
      itemSelecionadoPaciente: "",
      listaProfissionais: [],
      profissionalSelecionado: "",
      horaSelecionada: "",

      listaHorario: [
        { label: "Todos", value: "todos" },
        { label: "07:00", value: "07:00" },
        { label: "07:30", value: "07:30" },
        { label: "08:00", value: "08:00" },
        { label: "08:30", value: "08:30" },
        { label: "09:00", value: "09:00" },
        { label: "09:30", value: "09:30" },
        { label: "10:00", value: "10:00" },
        { label: "10:30", value: "10:30" },
        { label: "11:00", value: "11:00" },
        { label: "11:30", value: "11:30" },
        { label: "12:00", value: "12:00" },
        { label: "12:30", value: "12:30" },
        { label: "13:00", value: "13:00" },
        { label: "13:30", value: "13:30" },
        { label: "14:00", value: "14:00" },
        { label: "14:30", value: "14:30" },
        { label: "15:00", value: "15:00" },
        { label: "15:30", value: "15:30" },
        { label: "16:00", value: "16:00" },
        { label: "16:30", value: "16:30" },
        { label: "17:00", value: "17:00" },
        { label: "17:30", value: "17:30" },
        { label: "18:00", value: "18:00" },
        { label: "18:30", value: "18:30" },
        { label: "19:00", value: "19:00" },
        { label: "19:30", value: "19:30" },
        { label: "20:00", value: "20:00" },
        { label: "20:30", value: "20:30" },
        { label: "21:00", value: "21:00" },
      ],
      listaNomeSocial: [
        {
          label: "Todos",
          value: "todos",
        },
      ],
      nomeSocialSelecionado: "",
      listaFormasPagamento: [
        {
          label: "Todos",
          value: "todos",
        },
        {
          label: "Convenio",
          value: "convenio",
        },
        {
          label: "Pix",
          value: "pix",
        },
        {
          label: "Nao pagou",
          value: "nao_pagou",
        },
        {
          label: "Dinheiro",
          value: "dinheiro",
        },
        {
          label: "Isento",
          value: "isento",
        },
      ],
      pagamentoSelecionado: "",
      tipoServiço: [
        {
          label: "Todos",
          value: "todos",
        },
        {
          label: "Consulta",
          value: "consulta",
        },
        {
          label: "Avaliação",
          value: "avaliação",
        },
        {
          label: "Curso",
          value: "curso",
        },
      ],
      tipoServicoSelecionado: "",
              dataInicio: "",
        dataFim: "00000",
        showFilterDate: true,
        
        // 🔍 Novos filtros implementados
        filtroId: "",
        filtroProtocolo: "",
        filtroProtocolo2: "",
        filtroGuia: "",
            protocoloFilterTimer: null,

        // Timers para debounce
        idFilterTimer: null,
        protocoloFilterTimer: null,
        guiaFilterTimer: null,
        
        paginaAtual: 0,
      userLogado: "",
      nomePaciente: "",
      user: "",
      msgModalAdiantamento: "",
      temAdiantamento: false,
      valorConsultas: 0,
      mostrarValor: false,
      positionTooltip: {
        y: 0,
        x: 0,
      },
              filtroGuia: "",
        guiaSelecionada: "",
        
        // Propriedades de paginação server-side
        isLoading: false,
        fullOptionsLoaded: false,
        persistentFilterOptions: {
          patients: [],
          professionals: [],
          convenios: [],
          nomesSocial: [],
        },
        allPatientOptions: [],
        allProfessionalOptions: [],
        allConvenioOptions: [],
        allNomeSocialOptions: [],
        
        // Propriedades de exportação
        showExportModal: false,
        exportType: '', // 'excel' ou 'pdf'
        exportScope: '', // 'current' ou 'all'
        isExporting: false,
      allPacientes: [],
      carregouPacientes: false,
    };
  },
  computed: {
    // 🔒 Verificação de permissão para funcionalidades de admin
    isAdmin() {
      const userType = localStorage.getItem("type_name");
      const isAdminUser = userType === "Administrador" || userType === "Administrador-master";
      console.log("🔒 Admin check:", { userType, isAdminUser });
      return isAdminUser;
    },
    isProfessional() {
      return localStorage.getItem("type_name") === "Profissional";
    },
  },
  watch: {
    paginaAtual(newPage, oldPage) {},
  },
  methods: {
    getBadge(status) {
      return status == "Criada"
        ? "primary"
        : status === "Não Compareceu"
        ? "warning"
        : status === "Evolucao"
        ? "info"
        : status === "Sem Protocolo"
        ? "warning"
        : status === "Finalizada"
        ? "success"
        : status === "Cancelada"
        ? "danger"
        : status === "-"
        ? "info"
        : status === "Sem Guia"
        ? "warning"
        : "";
    },

    deleteModal() {
      this.showModal = false;
    },
    handlePaginationChange() {
      event.preventDefault();
      this.listItemProtocol = [];

      setTimeout(() => {
        let paginationLinks = document.querySelectorAll(".pagination a.page-link");
        paginationLinks.forEach((link) => {
          link.addEventListener("click", this.handlePaginationChange);
        });

        const rows = document.querySelectorAll("tr");
        rows.forEach((row) => {
          const badge = row.querySelector(".badge");
          if (badge) {
            const textContent = badge.textContent || badge.innerText;
            row.setAttribute("title", textContent.trim());
          }
        });
      }, 1000);
      let checkboxes = document.querySelectorAll('table tbody tr input[type="checkbox"]');

      setTimeout(() => {
        checkboxes.forEach((checkbox) => {
          checkbox.checked = false;
        });
      }, 1000);
    },
         listarConsultas() {
       console.log("listarConsultas called with page:", this.paginaAtual);

       // Skip if we're already loading (prevents multiple simultaneous requests)
       if (this.isLoading) {
         console.log("Skipping listarConsultas - already loading");
         return;
       }

       this.isLoading = true;

       this.idProfissional = localStorage.getItem("id");
       this.typeUser = localStorage.getItem("type_name");

       // Build filters object from all active filters
       const filters = {
         // 🔍 Novos filtros implementados
         id: this.filtroId || "",
         protocolo: this.filtroProtocolo || "",
             protocolo2: this.filtroProtocolo2 || "",

         guia: this.filtroGuia || this.guiaSelecionada || "",
         
         // Filtros existentes
         patient: this.itemSelecionadoPaciente || "",
         convenio: (this.convenioSelecionada === "todos" || !this.convenioSelecionada) ? "" : this.convenioSelecionada,
         statusconsulta: this.statusSelecionado || "",
         name: this.profissionalSelecionado || "",
         hour_at: this.horaSelecionada || "",
         social_name: this.nomeSocialSelecionado || "",
         pagamento: this.pagamentoSelecionado || "",
         name_service: this.tipoServicoSelecionado || "",
       };

       // Add date filters if they exist
       if (this.dataInicio && this.dataFim) {
         filters.dateRange = {
           start: this.dataInicio,
           end: this.dataFim,
         };
       }

       // Handle PROAP/PSI filter
       if (this.tipo_proapSelecionado === "proap") {
         filters.proap = 1;
       } else if (this.tipo_proapSelecionado === "psi") {
         filters.proap = 0;
       }

       // Sempre usar o endpoint consultass; quando for Profissional, enviar filtro de profissional (nome e id)
       const endpoint = `${process.env.VUE_APP_API_BASE_URL}consultass`;
       if (this.isProfessional) {
         // preferir filtro por nome (consistente com options), incluir id_professional como redundância
         filters.name = this.profissionalSelecionado || localStorage.getItem("name") || "";
         filters.id_professional = this.idProfissional || localStorage.getItem("id");
       }

       console.log(
         `Requesting page ${this.paginaAtual} of ${this.pages} (total: ${this.totalConsultas} items)`,
       );
       console.log("Making request to:", endpoint);
       console.log("With filters:", filters);

       // Simple request parameters - no offset manipulation
       const requestParams = {
         page: this.paginaAtual,
         limit: this.limit,
         filters: JSON.stringify(filters),
       };

       this.$http
         .get(endpoint, { params: requestParams })
         .then((res) => {
           console.log({ dscdscdsfdsfdsfsdf: res });
           console.log("Response received:", res.status);
           return res.json();
         })
         .then((response) => {
           console.log("Raw response:", response);
           
           // Check if response has the expected structure from Node-RED
           if (response.payload && Array.isArray(response.payload)) {
             console.log(
               `Received page ${response.paginaAtual || this.paginaAtual} of ${response.pages || 1} (total: ${response.totalItems || response.payload.length} items)`,
             );

             // Update pagination info from backend response
             this.totalConsultas = response.totalItems || response.payload.length;
             this.pages = response.pages || 1;
             
             // Update current page if provided by backend
             if (response.paginaAtual && response.paginaAtual !== this.paginaAtual) {
               console.log(
                 `Page corrected by server: ${this.paginaAtual} -> ${response.paginaAtual}`,
               );
               this.paginaAtual = response.paginaAtual;
             }

             // Update data - backend already processed the data
             this.consultas = response.payload;
           } else {
             // Fallback for old format or direct array response
             console.log("Using fallback format for response");
             this.consultas = Array.isArray(response) ? response : [];
             
             // TEMPORÁRIO: Estimativa baseada nos dados recebidos
             // Se recebemos exatamente 'limit' registros, provavelmente há mais páginas
             if (this.consultas.length === this.limit) {
               // Estimativa conservadora - assumir pelo menos 5 páginas se está completo
               this.totalConsultas = this.limit * 5; 
               this.pages = 5;
               console.log("Estimated pagination - likely more pages exist");
             } else {
               // Se recebeu menos que o limit, provavelmente é a última página
               this.totalConsultas = this.consultas.length;
               this.pages = this.paginaAtual;
               console.log("Detected last page based on incomplete results");
             }
           }

           // Process data only if needed (backend should handle most of this now)
           this.processConsultaData();

           // Set filtered data directly
           this.consultasFiltradas = this.consultas;

           // Save the complete filter options when they first arrive
           if (!this.fullOptionsLoaded && response.filterOptions) {
             this.persistentFilterOptions = {
               patients: response.filterOptions.patients || [],
               professionals:
                 response.filterOptions.professionals || [],
               convenios: response.filterOptions.convenios || [],
               nomesSocial:
                 response.filterOptions.nomesSocial || [],
             };
             this.fullOptionsLoaded = true;

             // Initialize with all options
             this.refreshSelectOptions(true);

             console.log(
               "Saved persistent filter options:",
               this.persistentFilterOptions,
             );
           } else if (response.filterOptions) {
             // Update allPatientOptions etc. for the current filters
             this.allPatientOptions =
               response.filterOptions.patients || [];
             this.allProfessionalOptions =
               response.filterOptions.professionals || [];
             this.allConvenioOptions =
               response.filterOptions.convenios || [];
             this.allNomeSocialOptions =
               response.filterOptions.nomesSocial || [];

             // Update dropdowns with current options
             this.refreshSelectOptions(false);
           }

           // Reset loading state
           this.isLoading = false;
           
           console.log(`Successfully loaded ${this.consultas.length} consultas for page ${this.paginaAtual}`);
         })
         .catch((err) => {
           console.error("Error in request:", err);
           this.alertaAviso = true;
           this.mensagem =
             "Erro ao carregar consultas. Tente novamente.";
           this.isLoading = false;
         });
     },

     // Métodos auxiliares para paginação server-side
     processConsultaData() {
       this.consultas.forEach((elem) => {
         // Your existing data processing logic
         elem.checkProtocol = false;
         
         // Check if date_at is already formatted by backend
         if (elem.date_at && !elem.date_at.includes("/")) {
           elem.date_at = moment.utc(elem.date_at).format("DD/MM/YYYY");
         }
         
         elem.guia = `1ª: ${elem.numeroguia ? elem.numeroguia : "-"}
           2º: ${elem.numguia2 ? elem.numguia2 : "-"}`;

         if (elem.pagamento == null) {
           elem.pagamento = "-";
         }

         if (elem.protocolo2 == null) {
           elem.protocolo2 = "-";
         }

         if (elem.patient == null) {
           elem.patient = "-";
         }

         if (elem.email == null) {
           elem.email = "-";
         }

         if (!elem.social_name) {
           elem.social_name = "-";
         } else {
           elem.social_name = elem.social_name
             .split(" ")
             .map(
               (nome) =>
                 nome.charAt(0).toUpperCase() +
                 nome.slice(1).toLowerCase(),
             )
             .join(" ");
         }

         // Check if pagamento is already formatted by backend
         if (elem.pagamento && typeof elem.pagamento === 'string') {
           elem.pagamento = elem.pagamento.replace("_", " ");
           console.log({ dsfsfsdfsdfsdfdsfdsfsd: elem.pagamento})
           if (elem.pagamento == "nao pagou") {
             elem._classes = "table-danger";
           }
         }
       });

       // Build filter options from the data
       this.updateFilterOptions();
     },

     updateFilterOptions() {
       // Reset filter arrays
       this.listaPacientesFiltro = [];
       this.listaNomeSocial = [{ label: "Todos", value: "todos" }];

       // Populate filter options from data
       this.consultas.forEach((elem) => {
         if (!this.listaPacientesFiltro.includes(elem.patient)) {
           this.listaPacientesFiltro.push(elem.patient);
         }
       });

       this.listaPacientesFiltroSelect = this.listaPacientesFiltro;
     },

     refreshSelectOptions(useFullOptions) {
       // If useFullOptions is true, use the persistent full list
       // Otherwise, use the filtered options from the current response
       if (useFullOptions) {
         // Reset to full list of options
         this.allPatientOptions = this.persistentFilterOptions.patients;
         this.allProfessionalOptions =
           this.persistentFilterOptions.professionals;
         this.allConvenioOptions =
           this.persistentFilterOptions.convenios;
         this.allNomeSocialOptions =
           this.persistentFilterOptions.nomesSocial;

         console.log("Using full filter options list");
       } else {
         console.log("Using current filter options list");
       }

       // Reset the filter display options to current lists
       this.listaPacientesFiltro = this.allPatientOptions;
       this.listaPacientesFiltroSelect = this.allPatientOptions;

       // Update convenios dropdown
       this.listaConvenios = [{ label: "Todos", value: "todos" }];
       this.allConvenioOptions.forEach((item) => {
         if (item) {
           this.listaConvenios.push({ label: item, value: item });
         }
       });

       // Update professionals dropdown
       this.listaProfissionais = [{ label: "Todos", value: "todos" }];
       this.allProfessionalOptions.forEach((item) => {
         if (item) {
           this.listaProfissionais.push({ label: item, value: item });
         }
       });

       // Update nome social dropdown
       this.listaNomeSocial = [{ label: "Todos", value: "todos" }];
       this.allNomeSocialOptions.forEach((item) => {
         if (item && item !== "-") {
           this.listaNomeSocial.push({ label: item, value: item });
         }
       });

       // Log current filter options counts
       console.log(
         `Filter options counts - Patients: ${this.listaPacientesFiltroSelect.length}, Professionals: ${this.listaProfissionais.length - 1}, Convenios: ${this.listaConvenios.length - 1}`,
       );
     },

     onPageChange(novaPagina, event) {
       console.log(`onPageChange called with page ${novaPagina}`);

       if (event) {
         event.preventDefault();
       }

       // Validate page number
       const validPage = Math.max(
         1,
         Math.min(this.pages, parseInt(novaPagina) || 1),
       );

       console.log(
         `Navigating from page ${this.paginaAtual} to page ${validPage}`,
       );

       // Force reset loading state regardless of whether page changed
       this.isLoading = false;

       // Update page number
       this.paginaAtual = validPage;

       // Explicitly call data loading
       setTimeout(() => {
         console.log(
           `Calling listarConsultas for page ${this.paginaAtual}`,
         );
         this.listarConsultas();
       }, 0);
     },

     goToToday() {
       // Show loading state
       this.isLoading = true;

       const todayPageUrl = `${process.env.VUE_APP_API_BASE_URL}consultass-today`;
       console.log("Requesting today's page from:", todayPageUrl);

       this.$http
         .get(todayPageUrl)
         .then((res) => res.json())
         .then((data) => {
           console.log("Today's page data:", data);
           if (data && data.todayPage) {
             console.log(
               `Setting page to ${data.todayPage} and loading data...`,
             );
             this.paginaAtual = data.todayPage;

             // Make sure we're not in loading state before calling listarConsultas
             this.isLoading = false;

             // Now explicitly call listarConsultas to load the data
             this.listarConsultas();
           } else {
             console.error(
               "Invalid response from today's page endpoint",
             );
             this.paginaAtual = 1;
             this.isLoading = false;
             this.listarConsultas();
           }
         })
         .catch((err) => {
           console.error("Failed to get today's page:", err);
           this.paginaAtual = 1;
           this.isLoading = false;
           this.listarConsultas();
                   });
      },

      // Métodos de Exportação Excel
      confirmExport(scope) {
        this.exportScope = scope;
        this.exportType = 'excel';
        this.showExportModal = false;
        
        if (scope === 'current') {
          this.executeExcelExport(this.consultas);
        } else {
          this.exportAllData();
        }
      },

      async exportAllData() {
        try {
          this.isExporting = true;
          console.log("Starting export all data...");
          
          const allData = await this.getAllDataForExport();
          this.executeExcelExport(allData);
          
        } catch (error) {
          console.error("Error during export:", error);
          this.alertaAviso = true;
          this.mensagem = "Erro ao exportar dados: " + error.message;
        } finally {
          this.isExporting = false;
        }
      },

      async getAllDataForExport() {
        try {
          // Build filters object from all active filters
          const filters = {
            patient: this.itemSelecionadoPaciente || "",
            convenio: (this.convenioSelecionada === "todos" || !this.convenioSelecionada) ? "" : this.convenioSelecionada,
            statusconsulta: this.statusSelecionado || "",
            name: this.profissionalSelecionado || "",
            hour_at: this.horaSelecionada || "",
            social_name: this.nomeSocialSelecionado || "",
            pagamento: this.pagamentoSelecionado || "",
            name_service: this.tipoServicoSelecionado || "",
            guia: this.guiaSelecionada || "",
          };

          // Add date filters if they exist
          if (this.dataInicio && this.dataFim) {
            filters.dateRange = {
              start: this.dataInicio,
              end: this.dataFim,
            };
          }

          // Handle PROAP/PSI filter
          if (this.tipo_proapSelecionado === "proap") {
            filters.proap = 1;
          } else if (this.tipo_proapSelecionado === "psi") {
            filters.proap = 0;
          }

          // Forçar export via /consultass (backend entende filtros)
          const endpoint = `${process.env.VUE_APP_API_BASE_URL}consultass`;
          const requestParams = {
            exportAll: true,
            filters: JSON.stringify(filters),
          };

          console.log("Requesting all data from:", endpoint);
          console.log("With params:", requestParams);

          const response = await this.$http
            .get(endpoint, { params: requestParams })
            .then((res) => res.json());

          console.log("All data response:", response);

          if (response.payload && Array.isArray(response.payload)) {
            return response.payload;
          } else {
            return Array.isArray(response) ? response : [];
          }

        } catch (error) {
          console.error("Erro ao buscar todos os dados:", error);
          throw new Error("Falha ao buscar todos os registros");
        }
      },

      async executeExcelExport(dataToExport) {
        try {
          console.log(`Exporting ${dataToExport.length} records to Excel`);
          
          // Preparar dados para exportação
          const exportData = dataToExport.map((consulta, index) => ({
            "ID": consulta.id,
            "Paciente": consulta.patient || "-",
            "Nome Social": consulta.social_name || "-", 
            "Convênio": consulta.idconvenio || "-",
            "Data": consulta.date_at || "-",
            "Hora": consulta.hour_at || "-",
            "Profissional": consulta.name || "-",
            "Pagamento": consulta.pagamento || "-",
            "Valor": consulta.valor || "-",
            "Serviço": consulta.name_service || "-",
            "Protocolo": consulta.protocol || "-",
            "GUIA": consulta.guia || "-",
            "Status": consulta.statusconsulta || "-",
            "Email": consulta.email || "-"
          }));

          // Criar workbook
          const wb = XLSX.utils.book_new();
          const ws = XLSX.utils.json_to_sheet(exportData);

          // Configurar largura das colunas
          ws['!cols'] = [
            { width: 8 },   // ID
            { width: 25 },  // Paciente
            { width: 20 },  // Nome Social
            { width: 15 },  // Convênio
            { width: 12 },  // Data
            { width: 8 },   // Hora
            { width: 20 },  // Profissional
            { width: 12 },  // Pagamento
            { width: 10 },  // Valor
            { width: 15 },  // Serviço
            { width: 15 },  // Protocolo
            { width: 20 },  // GUIA
            { width: 12 },  // Status
            { width: 25 }   // Email
          ];

          // Adicionar a planilha ao workbook
          XLSX.utils.book_append_sheet(wb, ws, "Consultas");

          // Nome do arquivo com timestamp
          const timestamp = new Date().toLocaleString('pt-BR').replace(/[/:]/g, '-').replace(/,/g, '');
          const fileName = `consultas_${this.exportScope}_${timestamp}.xlsx`;

          // Download do arquivo
          XLSX.writeFile(wb, fileName);

          console.log(`Excel file "${fileName}" exported successfully`);
          
          // Mostrar sucesso
          this.alertaSucesso = true;
          this.mensagem = `Relatório Excel exportado com sucesso! (${dataToExport.length} registros)`;

        } catch (error) {
          console.error("Error in Excel export:", error);
          throw new Error("Falha ao gerar arquivo Excel: " + error.message);
                 }
       },

       // Método para verificar se há filtros ativos
       hasActiveFilters() {
         return !!(
           // 🔍 Novos filtros
           this.filtroId ||
           this.filtroProtocolo ||
           this.filtroGuia ||
           this.guiaSelecionada ||
           
           // Filtros existentes
           this.itemSelecionadoPaciente ||
           (this.dataInicio && this.dataFim) ||
           this.statusSelecionado ||
           this.profissionalSelecionado ||
           (this.convenioSelecionada && this.convenioSelecionada !== "todos") ||
           this.nomeSocialSelecionado ||
           this.pagamentoSelecionado ||
           this.tipoServicoSelecionado ||
           this.tipo_proapSelecionado
         );
       },

    //   this.typeUser = localStorage.getItem("type_name");

    //   if (this.typeUser == "Profissional") {
    //     this.userLogado = false;
    //     this.$http
    //       .get(
    //         `${process.env.VUE_APP_API_BASE_URL}consultas-profissionall/${this.idProfissional}`
    //       )
    //       .then((res) => res.json())
    //       .then(
    //         (payload) => {
    //           this.consultas = payload;
    //           this.consultas.forEach((elem) => {
    //             elem.guia = `1ª: ${elem.numeroguia ? elem.numeroguia : "-"}
    //         2º: ${elem.numguia2 ? elem.numguia2 : "-"}`;
    //             ("");
    //             elem.name = elem.name;
    //             elem.name_service = elem.name_service;
    //             elem.checkProtocol = false;
    //             elem.date_at = moment.utc(elem.date_at).format("DD/MM/YYYY");
    //             elem.hour_at = elem.hour_at;
    //             if (elem.pagamento == null) {
    //               elem.pagamento = "-";
    //             }
    //             elem.pagamento = elem.pagamento.toUpperCase();
    //             if (elem.patient == null) {
    //               elem.patient = "-";
    //             }
    //             if (elem.email == null) {
    //               elem.email = "-";
    //             }
    //             if (!elem.social_name) {
    //               elem.social_name = "-";
    //             } else {
    //               elem.social_name = elem.social_name
    //                 .split(" ")
    //                 .map(
    //                   (nome) =>
    //                     nome.charAt(0).toUpperCase() +
    //                     nome.slice(1).toLowerCase()
    //                 )
    //                 .join(" ");
    //             }

    //             elem.pagamento = elem.pagamento.replace("_", " ");
    //             if (elem.pagamento == "NAO PAGOU") {
    //               elem._classes = "table-danger";
    //             }
    //             if (!this.listaPacientesFiltro.includes(elem.patient)) {
    //               this.listaPacientesFiltro.push(elem.patient);
    //             }
    //           });

    //           this.listaPacientesFiltroSelect = this.listaPacientesFiltro;

    //           this.tipoServicoSelecionado = "consulta";
    //           this.selecionaTipoServico("consulta");
    //           this.setPagina(); // Chamada para a função setPagina
    //         },
    //         (err) => {
    //           this.$router.push("/dashboard");
    //         }
    //       );
    //   } else {
    //     this.$http
    //       .get(process.env.VUE_APP_API_BASE_URL + "consultas")
    //       .then((res) => res.json())
    //       .then(
    //         (payload) => {
    //           this.consultas = payload;

    //           this.consultas.forEach((elem) => {
    //             elem.checkProtocol = false;
    //             elem.date_at = moment.utc(elem.date_at).format("DD/MM/YYYY");
    //             elem.guia = `1ª: ${elem.numeroguia ? elem.numeroguia : "-"}
    //         2º: ${elem.numguia2 ? elem.numguia2 : "-"}`;
    //             elem.name = elem.name;
    //             elem.name_service = elem.name_service;
    //             // elem.pagamento =
    //             //   elem.statusconsulta === "Não Compareceu"
    //             //     ? "nao_pagou"
    //             //     : elem.pagamento;
    //             if (elem.pagamento == null) {
    //               elem.pagamento = "-";
    //             } else {
    //               elem.pagamento[0].toUpperCase();
    //             }
    //             if (elem.patient == null) {
    //               elem.patient = "-";
    //             }
    //             if (elem.email == null) {
    //               elem.email = "-";
    //             }
    //             if (!elem.social_name) {
    //               elem.social_name = "-";
    //             } else {
    //               elem.social_name = elem.social_name.toUpperCase();
    //             }
    //             if (!elem.numeroguia) {
    //               elem.numeroguia = "-";
    //             }
    //             elem.pagamento = elem.pagamento.replace("_", " ").toUpperCase();
    //             elem.patient = elem.patient
    //               .split(" ")
    //               .map(
    //                 (nome) =>
    //                   nome.charAt(0).toUpperCase() + nome.slice(1).toLowerCase()
    //               )
    //               .join(" ");
    //             if (elem.pagamento == "NAO PAGOU") {
    //               elem._classes = "table-danger";
    //             }
    //             if (!this.listaPacientesFiltro.includes(elem.patient)) {
    //               this.listaPacientesFiltro.push(elem.patient);
    //             }
    //             if (!this.listaNomeSocial.includes(elem.social_name)) {
    //               this.listaNomeSocial.push(elem.social_name);
    //             }
    //           });
    //           this.listaPacientesFiltroSelect = this.listaPacientesFiltro;
    //           this.consultasFiltradas = this.consultas;
    //           this.filtroAtributo();

    //           this.consultasFiltradas.forEach((c) => {
    //             const dataString = c.date_at;
    //             const dataFormato = "DD/MM/YYYY";

    //             const data = moment(dataString, dataFormato);

    //             c.dateFormat = data.format();
    //           });
    //           this.consultasFiltradas.sort((a, b) => {
    //             const dataA = moment(a.dateFormat);
    //             const dataB = moment(b.dateFormat);

    //             if (dataA.isBefore(dataB)) {
    //               return -1;
    //             } else if (dataA.isAfter(dataB)) {
    //               return 1;
    //             } else {
    //               return 0;
    //             }
    //           });

    //           this.setPagina();
    //           this.selecionaTipoServico("consulta");
    //         },
    //         (err) => {
    //           this.$router.push("/dashboard");
    //         }
    //       );
    //   }
    //   this.filtroAtributo();
    // },
    setPagina() {
      this.consultasFiltradas.forEach((c) => {
        const dataString = c.date_at;
        const dataFormato = "DD/MM/YYYY";

        const data = moment(dataString, dataFormato);

        c.dateFormat = data.format();
      });
      const hoje = moment().startOf("day"); // Obter a data de hoje sem considerar o horário

      let indicePrimeiraConsultaHoje = this.consultasFiltradas.findIndex((consulta) => {
        const dataConsulta = moment(consulta.dateFormat);
        return dataConsulta.isSameOrAfter(hoje, "day");
      });

      if (indicePrimeiraConsultaHoje == -1 || indicePrimeiraConsultaHoje == 0) {
        indicePrimeiraConsultaHoje = 20;
      }
      this.paginaAtual = Math.ceil(indicePrimeiraConsultaHoje / 20);
    },
    cadastrar() {
      this.$router.push("../nova-consulta");
    },

    async deleteConsult(item) {
      event.stopPropagation();
      let user = localStorage.getItem("type");

      const temFinanceiro = await this.$http.get(
        `${process.env.VUE_APP_API_BASE_URL}verifica/financeiro/${item.id}`
      );

      if (item.statusconsulta != "Criada") {
        if (this.user != 1 && temFinanceiro.body.length > 0) {
          this.modal_cancel_consult = true;
          this.text_modal = `Esta consulta contem dados financeiros, comunique a administração`;
          this.btn_excluir_inModal = false;
          this.btn_cancelar_inModal = false;
          this.btn_voltar_inModal = true;
        } else {
          this.showModal = true;
          this.msgModal = "Tem certeza que deseja excluir esta consulta?";
          this.id_consult = item.id;
          this.status_consult = item.statusconsulta;
          this.btn_excluir_inModal = true;
        }
      } else {
        // if (user == "2") {
        //   this.showModal = true;
        //   this.msgModal =
        //     "Você não possui permissão para realizar a exclusão de consultas.";
        //   this.btn_excluir_inModal = false;
        //   this.btn_cancelar_inModal = false;
        //   this.btn_voltar_inModal = true;
        // } else {
        this.showModal = true;
        this.msgModal = "Tem certeza que deseja excluir esta consulta?";
        this.id_consult = item.id;
        this.status_consult = item.statusconsulta;
        this.btn_excluir_inModal = true;
      }
    },
    confirmCancel() {
      this.$http
        .put(`${process.env.VUE_APP_API_BASE_URL}cancelar-consulta`, {
          id: this.id_consult,
        })
        .then((res) => res.json())
        .then((res) => {
          this.modal_cancel_consult = false;
          this.listarConsultas();
        });
    },
    excluir() {
      this.showModal = false;
      // if (this.status_consult == "Criada") {
      this.$http
        .delete(
          `${process.env.VUE_APP_API_BASE_URL}consultas/excluir-consulta/${this.id_consult}`
        )
        .then((res) => res.json())
        .then(() => {
          this.showModal = false;
          this.listarConsultas();
        });
      // } else {
      //   this.modal_cancel_consult = true;
      //   this.text_modal = `Consulta está no estado de ${this.status_consult} e não pode ser excluída`;
      //   this.btn_excluir_inModal = false;
      //   this.btn_cancelar_inModal = false;
      //   this.btn_voltar_inModal = true;
      // }
    },
    cancelConsult(item) {
      this.temAdiantamento = false;
      event.stopPropagation();

      let user = localStorage.getItem("type");
      if (item.statusconsulta == "Criada") {
        if (user == "2") {
          this.modal_cancel_consult = true;
          this.text_modal =
            "Você não está autorizado a realizar o cancelamento de consultas.";
          this.btn_cancelar_inModal = false;
          this.btn_excluir_inModal = false;
          this.btn_voltar_inModal = true;
        } else {
          this.modal_cancel_consult = true;
          if (item.adiantamento == true) {
            this.temAdiantamento = true;
            this.msgModalAdiantamento = "Consulta com adiantamento !";
            this.text_modal = "Tem certeza que deseja cancelar esta consulta ?";
          } else {
            this.msgModalAdiantamento = "";
            this.text_modal = "Tem certeza que deseja cancelar esta consulta ?";
          }

          this.id_consult = item.id;
          this.btn_excluir_inModal = true;
          this.btn_cancelar_inModal = true;
          this.btn_voltar_inModal = false;
        }
      } else {
        this.btn_cancelar_inModal = false;
        this.btn_excluir_inModal = false;
        this.modal_cancel_consult = true;
        this.text_modal =
          "Consultas que não estão com status de criada não podem ser canceladas";
        this.btn_voltar_inModal = true;
      }
    },
    // função select

    setProtocol(item) {
      event.stopPropagation();
      if (this.checkedItems[item.id]) {
        this.checkedItems[item.id] = false; // Desmarcar
      } else {
        this.checkedItems[item.id] = true; // Marcar
      }
      item.checkProtocol = !item.checkProtocol;

      if (item.checkProtocol) {
        this.listItemProtocol.push({
          idLista: item.id,
          id: item.id,
          status: item.statusconsulta,
          name: item.patient,
        });
      } else {
        let index = -1;
        for (let i = 0; i < this.listItemProtocol.length; i++) {
          if (this.listItemProtocol[i].id == item.id) {
            index = i;
            this.listItemProtocol.splice(index, 1);
            break;
          }
        }
      }

      let divEnviarProtocolo = this.listItemProtocol.includes(
        (item) => item.status != "Criado" && item.status != "Finalizada"
      );
    },
    sendProtocol() {
      if (this.textProdocol != "") {
        this.$http
          .post(`${process.env.VUE_APP_API_BASE_URL}protocol/insert`, {
            item: this.listItemProtocol,
            protocolo: this.textProdocol,
          })
          .then((res) => {
            this.textProdocol = "";
            this.listItemProtocol = [];
            this.consultas = [];
            this.listarConsultas();
          });
      } else {
        alert("Protocolo esta vazio");
      }
    },
    getConvenios() {
      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}convenios`)
        .then((res) => res.json())
        .then((res) => {
          res.forEach((x) => {
            this.listaConvenios.push({
              label: x.name,
              value: x.name,
            });
          });
        });
    },

    fetchAllPacientes() {
      if (this.carregouPacientes) return;
      this.carregouPacientes = true;
      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}pacientes`)
        .then(res => res.json())
        .then(res => {
          // Extrair nomes (ou usar patient field) – garantindo fallback
            const nomes = res
              .map(p => p.patient || p.name || '')
              .filter(n => n && n !== '-')
              .map(n => n.trim())
              .filter(n => n.length > 0);
            // Deduplicar preservando ordem alfabética
            const set = Array.from(new Set(nomes));
            set.sort((a,b)=> a.localeCompare(b, 'pt-BR', { sensitivity:'base'}));
            this.allPacientes = set;
            this.listaPacientesFiltro = [...set];
            this.listaPacientesFiltroSelect = [...set];
        })
        .catch(err => {
          console.error('Erro ao carregar todos os pacientes', err);
          this.carregouPacientes = false; // permitir retry
        });
    },

    filtroBuscaPacientes() {
      const regex = new RegExp(this.filtroInputBusca, 'i');
      const base = this.allPacientes.length ? this.allPacientes : this.listaPacientesFiltro;
      this.listaPacientesFiltroSelect = base.filter(n => regex.test(n));
    },

    selecionaPaciente(item) {
      if (item == 'todos') item = '';
      this.itemSelecionadoPaciente = item;
      this.paramsUrl('paciente', this.itemSelecionadoPaciente);
      // Reset page and reload consultas server-side
      this.paginaAtual = 1;
      this.listarConsultas();
      this.nomePaciente = item;
    },
    listarPorfissionais() {
      return this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}profissionais`)
        .then((res) => res.json())
        .then((res) => {
          // construir lista limpa
          this.listaProfissionais = [];
          res.forEach((item) => {
            this.listaProfissionais.push({
              label: item.name,
              value: item.name,
              id: item.id,
            });
          });
          // ordenar alfabeticamente e garantir opção "Todos"
          this.listaProfissionais.sort((a, b) => a.label.localeCompare(b.label, 'pt-BR'));
          this.listaProfissionais.unshift({ label: "Todos", value: "todos" });

          // Se for usuário Profissional, pré-selecionar o próprio profissional (por nome)
          if (localStorage.getItem("type_name") === "Profissional") {
            const userId = parseInt(localStorage.getItem("id"), 10);
            const found = this.listaProfissionais.find((p) => p.id === userId);
            if (found) {
              this.profissionalSelecionado = found.value;
            } else {
              // fallback: tentar nome em localStorage
              const storedName = localStorage.getItem("name") || localStorage.getItem("username");
              if (storedName) this.profissionalSelecionado = storedName;
            }
            // manter filtro fixo na URL e local state
            this.paramsUrl("profissional", this.profissionalSelecionado || "");
          }
        })
        .catch((err) => {
          console.error("Erro listarPorfissionais:", err);
        });
    },
    selecionaConvenio(value) {
      console.log("🏥 Convênio selected:", value, typeof value);
      
      // Handle both string and object formats
      let convenioValue = value;
      if (typeof value === 'object' && value !== null) {
        convenioValue = value.value || value.key || value.label || "";
      }
      
      // Set the selected value
      this.convenioSelecionada = convenioValue;
      
      // Convert "todos" to empty string for backend
      const filterValue = (convenioValue === "todos") ? "" : convenioValue;

      console.log("🏥 Final convenio filter value:", filterValue);

      this.paramsUrl("convenio", filterValue);
      this.filtroAtributo("convenio", filterValue);
    },
    filtroStatus(item) {
      this.paramsUrl("status", this.statusSelecionado);
      if (this.statusSelecionado == "todos") this.statusSelecionado = "";
      this.filtroAtributo("status", this.statusSelecionado);
    },
    // 🔍 Filtro ID - busca parcial (contains) com debounce
    onIdFilterChange() {
      const value = this.filtroId; // v-model já atualiza a propriedade
      console.log("🔍 ID filter typing:", value);
      
      this.paramsUrl("id", value);
      
      // Limpar timer anterior
      if (this.idFilterTimer) {
        clearTimeout(this.idFilterTimer);
      }
      
      // Aplicar filtro após 500ms de pausa na digitação
      this.idFilterTimer = setTimeout(() => {
        console.log("🔍 ID filter applied:", value);
        this.paginaAtual = 1;
        this.listarConsultas();
      }, 500);
    },

      onProtocolo2FilterChange() {
    // Podemos reutilizar o mesmo timer ou criar um novo. Por clareza, vamos usar o mesmo.
    clearTimeout(this.protocolo2FilterTimer);
    this.protocolo2FilterTimer = setTimeout(() => {
      this.paginaAtual = 1;
      this.listarConsultas();
    }, 500);
  },

    // 🔍 Filtro Protocolo - busca parcial (contains) com debounce
    onProtocoloFilterChange() {
      const value = this.filtroProtocolo; // v-model já atualiza a propriedade
      console.log("🔍 Protocolo filter typing:", value);
      
      this.paramsUrl("protocolo", value);
      
      // Limpar timer anterior
      if (this.protocoloFilterTimer) {
        clearTimeout(this.protocoloFilterTimer);
      }
      
      // Aplicar filtro após 500ms de pausa na digitação
      this.protocoloFilterTimer = setTimeout(() => {
        console.log("🔍 Protocolo filter applied:", value);
        this.paginaAtual = 1;
        this.listarConsultas();
      }, 500);
    },

    // 🔍 Filtro Guia - busca parcial (contains) com debounce
    onGuiaFilterChange() {
      const value = this.guiaSelecionada; // v-model já atualiza a propriedade
      console.log("🔍 Guia filter typing:", value);
      
      this.filtroGuia = value; // Unificar ambas variáveis
      this.paramsUrl("guia", value);
      
      // Limpar timer anterior
      if (this.guiaFilterTimer) {
        clearTimeout(this.guiaFilterTimer);
      }
      
      // Aplicar filtro após 500ms de pausa na digitação
      this.guiaFilterTimer = setTimeout(() => {
        console.log("🔍 Guia filter applied:", value);
        this.paginaAtual = 1;
        this.listarConsultas();
        
        // Lógica dos checkboxes após o filtro ser aplicado
        setTimeout(() => {
          let linhas = document.querySelectorAll("table tbody tr");
          linhas.forEach((x) => {
            const arrayListItemProtocol = this.listItemProtocol.map((item) => item.id);
            const checkbox = x.querySelector('input[type="checkbox"]');
            
            if (checkbox && arrayListItemProtocol.includes(parseInt(x.cells[0].innerHTML))) {
              checkbox.checked = true;
            } else if (checkbox) {
              checkbox.checked = false;
            }
          });
        }, 1000);
      }, 500);
    },
    filtroProfissional(item) {
      if (this.profissionalSelecionado == "todos") this.profissionalSelecionado = "";
      this.paramsUrl("profissional", this.profissionalSelecionado);
      this.filtroAtributo("profissional", this.profissionalSelecionado);
    },
    filtroHora(item) {
      if (this.horaSelecionada == "todos") this.horaSelecionada = "";
      this.paramsUrl("hora", this.horaSelecionada);
      this.filtroAtributo("hora", this.horaSelecionada);
    },
    selecionaNomeSocial(item) {
      this.paramsUrl("nomesocial", this.nomeSocialSelecionado);
      if (this.nomeSocialSelecionado == "todos") this.nomeSocialSelecionado = "";

      this.filtroAtributo("nomesocial", this.nomeSocialSelecionado);
    },
    selecionaPagamento(item) {
      if (this.pagamentoSelecionado == "todos") this.pagamentoSelecionado = "";

      this.paramsUrl("nomesocial", this.nomeSocialSelecionado);
      this.filtroAtributo("formapagamento", this.pagamentoSelecionado);
    },
    selecionaTipoServico(item) {
      if (item == "consulta" || item == "avaliação") {
        this.escopoProap = true;
      } else {
        this.escopoProap = false;
      }

      if (this.tipoServicoSelecionado == "todos") this.tipoServicoSelecionado = "";

      this.paramsUrl("tiposervico", this.tipoServicoSelecionado);
      this.filtroAtributo("tiposervico", this.tipoServicoSelecionado);
    },
    async selecionaDataFilter($event) {
      console.log("🗓️ Date filter changed:", $event);
      
      const data = $event;
      this.dataInicio = data.start;
      this.dataFim = data.end;

      // Atualizar URL params
      this.paramsUrl("datainicio", this.dataInicio);
      this.paramsUrl("datafim", this.dataFim);

      // ✅ APLICAR FILTRO COM RESET PARA PÁGINA 1
      this.paginaAtual = 1;
      this.listarConsultas();

      console.log(`📅 Filter applied: ${this.dataInicio} to ${this.dataFim}`);
    },
    limpar(item) {
      console.log("🗓️ Clearing date filters");
      
      // Limpar variáveis de data
      this.dataInicio = "";
      this.dataFim = "";
      
      // Atualizar URL
      this.paramsUrl("datainicio", null);
      this.paramsUrl("datafim", null);
      
      // ✅ RESET PARA PÁGINA 1 E RECARREGAR
      this.paginaAtual = 1;
      this.listarConsultas();
      
      console.log("📅 Date filters cleared");
    },
    selecionaDataInicio(item) {
      if (!this.dataFim) {
        this.dataFim = this.dataInicio;
        this.paramsUrl("datafim", this.dataFim);
      }

      if (this.dataInicio == "") {
        this.dataInicio = null;
        this.dataFim = null;
        this.paramsUrl("datainicio", this.dataInicio);
        this.paramsUrl("datafim", this.dataFim);
      }

      this.paramsUrl("datainicio", this.dataInicio);
      this.filtroAtributo("datainicio", this.dataInicio);
    },
    selecionaDataFim(item) {
      if (!this.dataInicio) {
        this.dataInicio = this.dataFim;
        this.paramsUrl("datainicio", this.dataInicio);
        this.filtroAtributo("datafim", this.dataInicio);
      }
      this.paramsUrl("datafim", this.dataFim);
      this.filtroAtributo("datafim", this.dataFim);
    },
    proapFiltro() {
      this.paramsUrl("psiorproap", this.tipo_proapSelecionado);
      this.filtroAtributo("psiorproap", this.tipo_proapSelecionado);
    },
    // select serviços function
    filtrarServicos() {
      if (this.tipo_servicoSelecionado == 1 || this.tipo_servicoSelecionado == 2) {
        this.escopoProap = true;
      } else {
        this.escopoProap = false;
      }

      if (this.tipo_servicoSelecionado) {
        this.paramsUrl("servicotopo", this.tipo_servicoSelecionado);
        this.filtroAtributo("servicotopo", this.tipo_servicoSelecionado);
      } else {
        this.consultasFiltradas = this.consultas;
      }
    },
         filtroAtributo(chave, item) {
       // Update the relevant filter value
       if (chave && item) {
         this[chave] = item;
       }

       // Reset to first page when applying new filters
       this.paginaAtual = 1;

       // Call listarConsultas to reload with new filters
       this.listarConsultas();
     },
    convertParamUrl(item) {
      let urlParams = new URLSearchParams(window.location.search);
      const filtro = urlParams.get(item);
      return filtro;
    },
    filtroConsultas() {
      this.valorConsultas = 0;
      const regexNome = new RegExp(this.itemSelecionadoPaciente, "i");
      const regexConvenio = new RegExp(this.convenioSelecionada, "i");
      const regexStatus = new RegExp(this.statusSelecionado, "i");
      const regexProfessional = new RegExp(this.profissionalSelecionado, "i");
      const regexHora = new RegExp(this.horaSelecionada, "i");
      const regexNomeSocial = new RegExp(this.nomeSocialSelecionado, "i");
      const regexPagamento = new RegExp(this.pagamentoSelecionado, "i");
      const regexTipoServico = new RegExp(this.tipoServicoSelecionado, "i");
      const regexGuia = new RegExp(this.guiaSelecionada, "i");

      this.consultasFiltradas = this.consultas.filter(
        (consulta) =>
          regexNome.test(consulta.patient) &&
          regexConvenio.test(consulta.convenio) &&
          regexStatus.test(consulta.statusconsulta) &&
          regexProfessional.test(consulta.name) &&
          regexHora.test(consulta.hour_at) &&
          regexNomeSocial.test(consulta.social_name) &&
          regexPagamento.test(consulta.pagamento) &&
          regexTipoServico.test(consulta.name_service) &&
          regexGuia.test(consulta.numeroguia) &&
          regexGuia.test(consulta.numguia2)
      );

      if (this.tipo_proapSelecionado == 0) {
      }

      if (this.tipo_proapSelecionado == "psi") {
        this.consultasFiltradas = this.consultasFiltradas.filter(
          (consulta) => consulta.proap == 0
        );
      }
      if (this.tipo_proapSelecionado == "proap") {
        this.consultasFiltradas = this.consultasFiltradas.filter(
          (consulta) => consulta.proap == 1
        );
      }

      if (this.dataInicio && this.dataFim) {
        this.consultasFiltradas = this.consultasFiltradas.filter(
          (consulta) =>
            moment(consulta.date_at, "DD/MM/YYYY").toDate() >=
              moment(this.dataInicio, "YYYY-MM-DD").toDate() &&
            moment(consulta.date_at, "DD/MM/YYYY").toDate() <=
              moment(this.dataFim, "YYYY-MM-DD").toDate()
        );
      }
      this.setPagina();

      const options = {
        style: "currency",
        currency: "BRL",
      };
      for (let consulta of this.consultasFiltradas) {
        if (this.dataInicio != null) {
          let valor = parseFloat(consulta.valor.slice(2).replace(",", "."));

          if (consulta.pagamento != "NAO PAGOU") {
            this.valorConsultas += valor;
          }
        }
      }
      if (this.valorConsultas > 0) {
        this.mostrarValor = true;
      }
      this.valorConsultas = Intl.NumberFormat("pt-BR", options).format(
        this.valorConsultas
      );

      setTimeout(() => {
        let paginationLinks = document.querySelectorAll(".pagination a.page-link");
        paginationLinks.forEach((link) => {
          link.addEventListener("click", this.handlePaginationChange);
        });
        const rows = document.querySelectorAll("tr");
        rows.forEach((row) => {
          const badge = row.querySelector(".badge");
          if (badge) {
            const textContent = badge.textContent || badge.innerText;
            row.setAttribute("title", textContent.trim());
          }
        });
      }, 2000);
    },
    paramsUrl(chave, valor) {
      if (!valor) valor = "todos";
      const urlParams = new URLSearchParams(window.location.search);
      const baseUrl = window.location.href.split("?")[0];

      if (urlParams.get(chave)) {
        const urlSearchParams = new URLSearchParams(window.location.search);
        urlSearchParams.set(chave, valor);
        const novaUrl = baseUrl + "?" + urlSearchParams.toString();
        const novoEstado = { paciente: valor };
        window.history.pushState(novoEstado, "", novaUrl);
      } else {
        const params = new URLSearchParams(window.location.search);
        params.append(chave, valor);
        // usar window.location.pathname para garantir caminho correto
        const novaUrl = window.location.pathname + "?" + params.toString();
        const novoEstado = { paciente: valor };
        window.history.pushState(novoEstado, "", novaUrl);
      }
    },
    limparFiltro() {
      this.selecionaPaciente("todos");
    },
    perfilConsulta(item) {
      this.$router.push({
        path: `consultas`,
        name: "Consultas",
        query: { id: item.id, type: "b" },
      });
    },
    uncheckAll() {
      this.consultasFiltradas.forEach((item) => {
        this.$set(item, "checkProtocol", false);
        return item;
      });
    },
    excluirConsultas() {
      const x = this.listItemProtocol.find(
        (x) => x.status != "Criada" && x.status != "Cancelada"
      );
      if (x) {
        this.alertaAviso = true;
        this.mensagem =
          "Apenas consultas com status 'criada' ou 'cancelada' podem ser excluídas.";
        return;
      }

      this.listItemProtocol.forEach(async (x) => {
        try {
          const response = await this.$http
            .delete(
              `${process.env.VUE_APP_API_BASE_URL}consultas/excluir-consulta/${x.id}`
            )
            .then(async () => {
              const index = this.consultasFiltradas.findIndex((item) => item.id === x.id);
              this.consultasFiltradas.splice(index, 1);
              document.getElementById(`${x.id}`).checked = false;
            });
        } catch (error) {
          console.error(error);
        }
      });

      this.listItemProtocol = [];

      this.handlePaginationChange();
      // window.location.reload();

      this.consultasFiltradas.forEach((x) => {
        x.checkProtocol = false;
      });
    },
    // handlePaginationChange() {
    //   event.preventDefault(); // previne a ação padrão do link

    // },
    LimparFiltros() {
      console.log("🧹 Limpando todos os filtros...");
      
      // 🔍 Limpar timers de debounce
      if (this.idFilterTimer) {
        clearTimeout(this.idFilterTimer);
        this.idFilterTimer = null;
      }
      if (this.protocoloFilterTimer) {
        clearTimeout(this.protocoloFilterTimer);
        this.protocoloFilterTimer = null;
      }
      if (this.guiaFilterTimer) {
        clearTimeout(this.guiaFilterTimer);
        this.guiaFilterTimer = null;
      }
      
      // 🔍 Limpar novos filtros
      this.filtroId = "";
      this.filtroProtocolo = "";
      this.filtroGuia = "";
      this.guiaSelecionada = "";
      
      // Limpar filtros existentes
      this.itemSelecionadoPaciente = "";
      this.dataInicio = "";
      this.dataFim = "";
      this.statusSelecionado = "";
      this.profissionalSelecionado = "";
      this.convenioSelecionada = "todos";
      this.nomeSocialSelecionado = "";
      this.pagamentoSelecionado = "";
      this.tipoServicoSelecionado = "";
      this.tipo_proapSelecionado = "";
      this.nomePaciente = "";
      
      // Reset página para 1
      this.paginaAtual = 1;
      
      // Limpar URL
      var url = window.location.href;
      if (url.indexOf("?") !== -1) {
        url = url.split("?")[0];
        window.history.pushState({}, "", url);
      }
      
      // Recarregar dados sem filtros
      this.listarConsultas();
      
      console.log("✅ Todos os filtros foram limpos!");
    },

     hydrateFiltersFromQuery() {
      const qs = (this.$route && this.$route.query)
        ? this.$route.query
        : Object.fromEntries(new URLSearchParams(window.location.search));
      const norm = v => (!v || v === 'todos' ? '' : v);

      this.itemSelecionadoPaciente = norm(qs.paciente);
      this.nomePaciente = this.itemSelecionadoPaciente;
      this.nomeSocialSelecionado = norm(qs.nomesocial);
      if (qs.convenio) {
        this.convenioSelecionada = qs.convenio === 'todos' ? 'todos' : qs.convenio;
      }
      this.statusSelecionado = norm(qs.status);
      this.profissionalSelecionado = norm(qs.profissional);
      this.horaSelecionada = norm(qs.hora);
      this.tipoServicoSelecionado = norm(qs.tiposervico);
      this.tipo_proapSelecionado = norm(qs.psiorproap);
      this.filtroId = qs.id || '';
      this.filtroProtocolo = qs.protocolo || '';
      this.guiaSelecionada = qs.guia || '';
      this.filtroGuia = this.guiaSelecionada;

      if (qs.datainicio && qs.datafim) {
        this.dataInicio = qs.datainicio;
        this.dataFim = qs.datafim;
      }

      if (this.tipoServicoSelecionado === 'consulta' || this.tipoServicoSelecionado === 'avaliação') {
        this.escopoProap = true;
      } else if (this.tipoServicoSelecionado) {
        this.escopoProap = false;
      }
    },
  },

  mounted() {
    console.log("Component mounted - starting initialization");
    this.initialLoadComplete = false;
    this.isLoading = false;

    // carregar dados auxiliares
    this.getConvenios();
    this.hydrateFiltersFromQuery();
    this.listarPorfissionais().then(() => {
      this.user = localStorage.getItem("type");
      // já com profissional selecionado quando aplicável
      this.listarConsultas();
      this.fetchAllPacientes();
    });

    // Set up badges
    setTimeout(() => {
      const rows = document.querySelectorAll("tr");
      rows.forEach((row) => {
        const badge = row.querySelector(".badge");
        if (badge) {
          const textContent = badge.textContent || badge.innerText;
          row.setAttribute("title", textContent.trim());
        }
      });
    }, 2000);
  },
};
</script>
<style scoped>
.check__box {
  margin-left: 1rem;
  height: 2rem;
}
.pb-4,
.py-4 {
  padding: 10px !important;
}
.badge {
  font-size: 100%;
}
.div-body-modal {
  text-align-last: center;
}
.div-body-modal button {
  background: red;
  border: none;
  font-weight: 500;

  width: 10vw;
  border-radius: 10px;
  height: 2vw;
  color: white;
  transition: all 0.3s;
}
.div-body-modal button:hover {
  background: white;
  font-weight: 500;
  color: red;
  border: 1px solid red;
  transition: all 0.3s;
}
.modal-excluir-consulta h6 {
  text-align-last: center;
  margin-top: 3vw;
}
.btn-modal {
  margin-left: 10px;
}
.div__protocol {
  margin-top: 0.5rem;
  display: flex;
  justify-content: start;
  gap: 2rem;
}
@media (max-width: 480px) {
  .servicos-div {
    width: 100%;
  }
}
@media (min-width: 769px) {
  .servicos-div {
    width: 30%;
  }
}
.form-group {
  margin-bottom: 0;
}
.input_data {
  padding: 0.4rem;
  border-radius: 4px;
  border: 1px solid #c3c3c3;
}
.dropdown .dropdown-menu.show {
  display: block;
  overflow: scroll !important;
  height: 300px !important;
}
.border {
  border: 1px solid #c3c3c3;
  border-radius: 4px;
}
.dropdownBusca {
  display: flex;
  justify-content: center;
  border: 1px solid #c3c3c3;
  border-radius: 4px;
}
.form-control.form-control-sm {
  height: 38px !important;
}
.table-consulta tr[data-v-431cdece] td:last-child {
  display: none !important;
}
.alert_adiantamento {
  font-size: 1.5rem;
  color: red;
}
.table-consulta table tbody tr:hover {
  background-color: aqua !important;
}
.tootip-status {
  position: absolute;
  border: 1px solid black;
  padding: 10px;
  z-index: 1000;
}
.text-modal {
  font-size: 1.5rem;
  text-align: center;
}

/* 🎯 MODAL DE EXPORTAÇÃO PROFISSIONAL */

/* Container principal */
.modal-export-options {
  z-index: 1055;
}

.export-modal-body {
  background: #ffffff;
  border-radius: 12px;
  padding: 0;
  max-width: 100%;
  position: relative;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
}

/* 📋 Header Section */
.export-header {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 12px 12px 0 0;
  padding: 25px 30px;
  text-align: center;
  border-bottom: 1px solid #dee2e6;
}

.export-main-title {
  color: #2c3e50;
  font-size: 24px;
  font-weight: 600;
  margin: 15px 0 8px 0;
  letter-spacing: -0.5px;
}

.export-subtitle {
  color: #6c757d;
  font-size: 15px;
  margin: 0;
  font-weight: 400;
}

/* 📊 Info Section */
.export-info-section {
  padding: 25px 30px;
  background: #ffffff;
}

.info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.info-card {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 10px;
  padding: 20px;
  text-align: center;
  transition: transform 0.2s ease;
}

.info-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
}

.info-icon {
  font-size: 28px;
  margin-bottom: 10px;
  display: block;
}

.info-number {
  font-size: 22px;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 5px;
}

.info-label {
  font-size: 13px;
  color: #6c757d;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* 🎯 Options Section */
.export-options-section {
  padding: 20px 30px;
  background: #ffffff;
}

.options-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

/* Sobrescreve estilos globais de botão vermelho */
.export-choice-btn {
  background: #ffffff !important;
  border: 2px solid #e9ecef !important;
  border-radius: 12px !important;
  padding: 25px 20px !important;
  cursor: pointer !important;
  transition: all 0.3s ease !important;
  text-align: center !important;
  width: 100% !important;
  height: auto !important;
  min-height: 140px !important;
  display: flex !important;
  flex-direction: column !important;
  justify-content: center !important;
  align-items: center !important;
  position: relative !important;
  color: #2c3e50 !important;
  font-weight: normal !important;
}

.export-choice-btn:hover {
  background: #f8f9fa !important;
  border-color: #007bff !important;
  transform: translateY(-3px) !important;
  box-shadow: 0 8px 25px rgba(0,123,255,0.15) !important;
  color: #007bff !important;
}

.export-choice-btn:disabled {
  opacity: 0.5 !important;
  cursor: not-allowed !important;
  pointer-events: none !important;
  background: #f8f9fa !important;
}

.current-choice:hover {
  border-color: #28a745 !important;
  color: #28a745 !important;
  box-shadow: 0 8px 25px rgba(40,167,69,0.15) !important;
}

.all-choice:hover {
  border-color: #17a2b8 !important;
  color: #17a2b8 !important;
  box-shadow: 0 8px 25px rgba(23,162,184,0.15) !important;
}

.choice-icon {
  font-size: 32px;
  margin-bottom: 12px;
  opacity: 0.8;
}

.choice-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 8px;
  color: inherit;
}

.choice-count {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 6px;
  color: inherit;
}

.choice-description {
  font-size: 13px;
  opacity: 0.7;
  font-style: italic;
  color: inherit;
}

/* 🔍 Filtros Ativos */
.active-filters-section {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 10px;
  padding: 20px;
  margin: 20px 30px;
}

.filters-header {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  gap: 8px;
}

.filters-icon {
  font-size: 16px;
}

.filters-title {
  font-weight: 600;
  color: #495057;
  font-size: 15px;
  margin: 0;
}

.filters-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.filter-tag {
  background: #ffffff;
  border: 1px solid #dee2e6;
  border-radius: 20px;
  padding: 6px 12px;
  font-size: 12px;
  color: #495057;
  display: inline-block;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.filter-tag strong {
  color: #007bff;
}

/* 🦶 Footer */
.export-footer {
  background: #f8f9fa;
  border-radius: 0 0 12px 12px;
  padding: 20px 30px;
  border-top: 1px solid #dee2e6;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.footer-info {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
}

.info-icon {
  font-size: 16px;
}

.info-message {
  color: #6c757d;
  font-size: 14px;
  font-style: italic;
}

.footer-actions {
  display: flex;
  gap: 10px;
}

/* Sobrescreve botão vermelho global */
.cancel-btn {
  background: #6c757d !important;
  color: white !important;
  border: 1px solid #6c757d !important;
  border-radius: 8px !important;
  padding: 10px 20px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  cursor: pointer !important;
  transition: all 0.3s ease !important;
  width: auto !important;
  height: auto !important;
  min-height: auto !important;
}

.cancel-btn:hover {
  background: #5a6268 !important;
  border-color: #5a6268 !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(108,117,125,0.3) !important;
  color: white !important;
}

/* ⏳ Loading Overlay */
.export-loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255,255,255,0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  z-index: 1000;
  backdrop-filter: blur(2px);
}

.loading-content {
  text-align: center;
  padding: 40px;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 15px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-content h4 {
  color: #2c3e50;
  font-size: 18px;
  margin-bottom: 8px;
  font-weight: 600;
}

.loading-content p {
  color: #6c757d;
  font-size: 14px;
  margin: 0;
}

/* 📱 Responsividade */
@media (max-width: 768px) {
  .export-header,
  .export-info-section,
  .export-options-section,
  .active-filters-section {
    padding-left: 20px;
    padding-right: 20px;
  }
  
  .info-grid,
  .options-grid {
    grid-template-columns: 1fr;
    gap: 15px;
  }
  
  .export-choice-btn {
    min-height: 120px !important;
    padding: 20px 15px !important;
  }
  
  .choice-icon {
    font-size: 28px;
    margin-bottom: 10px;
  }
  
  .choice-title {
    font-size: 15px;
  }
  
  .choice-count {
    font-size: 16px;
  }
  
  .export-footer {
    flex-direction: column;
    gap: 15px;
    text-align: center;
  }
  
  .footer-info {
    justify-content: center;
  }
}

/* 📊 PAGINAÇÃO INFO */
.pagination-info {
  margin-left: 10px;
  font-size: 14px;
  color: #666;
}

.pagination-extras {
  padding-left: 2%;
  margin-top: 10px;
  display: flex;
  align-items: center;
}
</style>
  margin-top: 10px;
  display: flex;
  align-items: center;
}
</style>
